// extracted by mini-css-extract-plugin
module.exports = {"track":"marquee_track__5J9Fp","run":"marquee_run__Ze5KL","right":"marquee_right__DfrFC","bar":"marquee_bar__PzjuO","echo":"marquee_echo__mRaNo"};